import _SvgIcon from "@mui/material/SvgIcon";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
export function MapErrorIcon(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon, _extends({
    viewBox: "0 0 54 54"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7560_4540)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.0387 50.4716L48.9797 35.5856L47.3599 29.6648L46.1775 25.3359C45.8463 24.1224 44.7449 23.2801 43.487 23.2784H10.5125C9.2547 23.2801 8.15327 24.1224 7.82202 25.3359L4.80576 36.3769L3.46515 41.3017L0.960895 50.4716C0.731414 51.3124 0.907532 52.2122 1.43715 52.9043C1.96677 53.5964 2.78915 54.0017 3.66067 54H50.3389C51.4098 54.0036 52.3877 53.3915 52.8524 52.4267C53.1531 51.8201 53.2194 51.124 53.0387 50.4716Z",
    fill: "#97D391"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4466 45.3045L8.1944 53.9997H3.66067C2.78915 54.0014 1.96677 53.5962 1.43715 52.904C0.907532 52.2119 0.731414 51.3121 0.960895 50.4714L3.46515 41.3014L15.4466 45.3045Z",
    fill: "#86D1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8527 52.4265L43.7479 49.3823H43.7386L38.8418 47.7531L48.9799 35.5854L53.0388 50.4715C53.2197 51.1238 53.1534 51.8199 52.8527 52.4265Z",
    fill: "#86D1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8521 52.4267C52.3873 53.3915 51.4095 54.0035 50.3386 54H41.4665L30.2112 50.239L20.5665 47.0179L14.748 54.0001H8.1941L15.4463 45.3049L3.46484 41.3017L4.80545 36.3769L26.022 43.4708L26.804 43.7315L33.7117 46.0402L47.3596 29.6647L48.9794 35.5855L38.8413 47.7532L43.7382 49.3823H43.7474L52.8521 52.4267Z",
    fill: "#FFE27D"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M38.5375 4.57909C44.8012 10.6845 44.8012 20.6494 38.5375 26.7548L30.5256 34.5449C28.6281 36.3898 25.6069 36.3898 23.7094 34.5449L15.6975 26.7548C9.43385 20.6494 9.43385 10.6845 15.6975 4.57909C21.9927 -1.52636 32.2423 -1.52636 38.5375 4.57909Z",
    fill: "url(#paint0_linear_7560_4540)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M27.1169 3.97803C33.7601 3.97803 39.1063 9.22935 39.1063 15.6511C39.1063 22.1046 33.7601 27.3242 27.1169 27.3242C20.5053 27.3242 15.1274 22.1046 15.1274 15.6511C15.1274 9.22935 20.5053 3.97803 27.1169 3.97803Z",
    fill: "url(#paint1_linear_7560_4540)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.429 15.9918L31.8009 12.6198C32.1738 12.2469 32.1738 11.6442 31.8009 11.2714C31.4281 10.8985 30.8254 10.8985 30.4525 11.2714L27.0806 14.6434L23.7086 11.2714C23.3358 10.8985 22.7331 10.8985 22.3602 11.2714C21.9874 11.6442 21.9874 12.2469 22.3602 12.6198L25.7322 15.9918L22.3602 19.3639C21.9874 19.7367 21.9874 20.3394 22.3602 20.7123C22.5462 20.8982 22.7903 20.9917 23.0344 20.9917C23.2785 20.9917 23.5227 20.8982 23.7086 20.7123L27.0806 17.3403L30.4525 20.7123C30.6385 20.8982 30.8826 20.9917 31.1267 20.9917C31.3708 20.9917 31.615 20.8982 31.8009 20.7123C32.1738 20.3394 32.1738 19.7367 31.8009 19.3639L28.429 15.9918Z",
    fill: "#D34949"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint0_linear_7560_4540",
    x1: "10.9964",
    x2: "43.2476",
    y1: "18.9249",
    y2: "18.9249"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D34949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#F36565"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint1_linear_7560_4540",
    x1: "15.1165",
    x2: "39.1222",
    y1: "15.6621",
    y2: "15.6621"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.490196",
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7560_4540"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    height: "54",
    width: "54"
  }))));
}